/**
 * @flow
 * @author: VaraKumar
 */

import styled from 'react-emotion'

import { mobile, tablet, mdDesktop } from '../../../../../utils/mixins'

import { Typo13WhiteTwoDD } from '../../../../../themes/Fonts/Din2014'
import CloudinaryS3LazyLoadedImage from '../../../../CloudinaryS3LazyLoadedImage'

import Colors from '../../../../../themes/Colors'

export const MainContainer = styled('div')`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 100%;
  ${mobile} {
    display: block;
    margin-bottom: ${props => (props.excludeBottomMargin ? 0 : '12px')};
  }
  ${tablet} {
    margin-bottom: ${props => (props.excludeBottomMargin ? 0 : ' 0.9375em')};
    display: block;
  }
  ${mdDesktop} {
    margin-bottom: ${props => (props.excludeBottomMargin ? 0 : ' 0.9375em')};
    display: block;
  }
`

export const ThumbnailImgContainer = styled(CloudinaryS3LazyLoadedImage)`
  height: auto;
  width: 100%;
  object-fit: cover;
`
export const IconContainer = styled('div')`
  user-select: none;
  pointer-events: none;
`

export const PlayButtonText = styled(Typo13WhiteTwoDD)`
  margin-left: 10px;
  color: ${Colors.white};
`
export const PlayButtonContainer = styled('div')`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${Colors.black55};
  position: absolute;
  bottom: 15px;
  right: 15px;
  padding-left: 10px;
  padding-right: 10px;
  height: 30px;
  border-radius: 2px;
`

export const ThumbnailImgSection = styled('div')``

export const ThumbnailVideo = styled('video')``



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/VideoTestimonial/styledComponents.js